import { mapGetters, mapActions } from "vuex";
import { UserService } from "@/services";
import * as types from "@/store/types";
export default {
  name: "dashboard-authorization-card",
  components: {},
  props: [],
  data() {
    return {
      dashboardAuthorizationLoader: true
    };
  },
  computed: {
    ...mapGetters({
      getVerifyData: types.userVerifyInfo.getters.GET_USER_VERIFY_INFO
    })
  },
  mounted() {
    this.getAuthVerifyInfo();
  },
  methods: {
    // ...mapActions({
    //   setVerifyData: types.userVerifyInfo.actions.SET_USER_VERIFY_INFO
    // }),
    // getAuthVerifyInfo() {
    //   UserService.getVerifyInfo().then(response => {
    //     this.setVerifyData(response.data.data);
    //   });
    // }
    ...mapActions({
      setVerifyData: types.userVerifyInfo.actions.SET_USER_VERIFY_INFO
    }),
    getAuthVerifyInfo() {
      UserService.getVerifyInfo()
        .then(response => {
          this.setVerifyData(response.data.data);
        })
        .finally(() => {
          this.dashboardAuthorizationLoader = false;
        });
    },
    goToKYC() {
      this.$router.push({ name: "personal" });
    }
  }
};
